import React from 'react';

import { INSULATION_KIND, KIND_LABELS } from '../../utils/insulationCatalog.js';

/**
 * Вид материала и три фильтра задания: применение, толщина, плотность/прочность.
 *
 * Своего состояния не держит — всё приходит сверху, чтобы таблица и сводка
 * считались от тех же значений, что показаны в фильтрах.
 */
const InsulationPickerFilters = ({
  kind,
  onKindChange,
  measure,
  applicationOptions,
  applicationKeys,
  onToggleApplication,
  thicknessOptions,
  thicknesses,
  onToggleThickness,
  range,
  onRangeChange,
  measureBounds,
}) => (
  <>
    {/* Вид материала стоит над фильтрами, потому что он меняет сам третий
        фильтр: у ЭППС задание требует прочность на сжатие вместо плотности. */}
    <div className="ins-pick__kinds" role="group" aria-label="Вид материала">
      {[INSULATION_KIND.MINERAL, INSULATION_KIND.EXTRUDED].map((value) => (
        <button
          key={value}
          type="button"
          className={`ins-pick__kind${kind === value ? ' is-active' : ''}`}
          aria-pressed={kind === value}
          onClick={() => onKindChange(value)}
        >
          {KIND_LABELS[value]}
        </button>
      ))}
    </div>

    <div className="ins-pick__filters">
      <div className="ins-pick__filter">
        <span className="ins-pick__filter-title">По применению</span>
        <div className="ins-pick__chips">
          {applicationOptions.map((option) => (
            <button
              key={option.key}
              type="button"
              className={`ins-pick__chip${applicationKeys.includes(option.key) ? ' is-active' : ''}`}
              aria-pressed={applicationKeys.includes(option.key)}
              disabled={option.count === 0}
              title={option.count === 0 ? 'Под это применение товаров в прайсах нет' : undefined}
              onClick={() => onToggleApplication(option.key)}
            >
              {option.label}
              <span className="ins-pick__chip-count">{option.count}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="ins-pick__filter">
        <span className="ins-pick__filter-title">По толщине, мм</span>
        <div className="ins-pick__chips">
          {thicknessOptions.length === 0 && (
            <span className="ins-pick__empty-note">Толщина не указана ни у одной позиции</span>
          )}
          {thicknessOptions.map((value) => (
            <button
              key={value}
              type="button"
              className={`ins-pick__chip${thicknesses.includes(value) ? ' is-active' : ''}`}
              aria-pressed={thicknesses.includes(value)}
              onClick={() => onToggleThickness(value)}
            >
              {value}
            </button>
          ))}
        </div>
      </div>

      <div className="ins-pick__filter ins-pick__filter--range">
        <span className="ins-pick__filter-title">
          {measure.title}, {measure.unit}
        </span>
        <div className="ins-pick__range">
          <input
            type="text"
            inputMode="numeric"
            className="ins-pick__range-input"
            placeholder={measureBounds ? String(Math.floor(measureBounds.min)) : 'от'}
            aria-label={`${measure.title} от`}
            value={range.from}
            onChange={(event) => onRangeChange('from', event.target.value)}
          />
          <span className="ins-pick__range-dash">—</span>
          <input
            type="text"
            inputMode="numeric"
            className="ins-pick__range-input"
            placeholder={measureBounds ? String(Math.ceil(measureBounds.max)) : 'до'}
            aria-label={`${measure.title} до`}
            value={range.to}
            onChange={(event) => onRangeChange('to', event.target.value)}
          />
        </div>
      </div>
    </div>
  </>
);

export default InsulationPickerFilters;
